// Modules
import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'

// Application
import Routes from './router'
import { LoginProvider } from 'context'
import { ApolloClientProvider } from 'modules/ApolloClient'
import { RemoteConfigProvider } from 'modules/RemoteConfig'
import { useLogInfo } from 'redesign/hooks/useLogInfo'

const App = () => {
    const { addLogInfo } = useLogInfo()

    useEffect(() => {
        addLogInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <React.Suspense fallback={<h6>Loading Microfrontends</h6>}>
            <ApolloClientProvider>
                <RemoteConfigProvider>
                    <LoginProvider>
                        <BrowserRouter>
                            <Routes />
                        </BrowserRouter>
                    </LoginProvider>
                </RemoteConfigProvider>
            </ApolloClientProvider>
        </React.Suspense>
    )
}

export default App
